import Helmet from "react-helmet"
import parse from "html-react-parser"

export const PageSEO = ({ seo }) => {
  return (
    <Helmet>

      <html lang="en" />
      {seo && "metaTitleContainer" in seo && parse(seo.metaTitleContainer)}
      {seo && "metaTagContainer" in seo && parse(seo.metaTagContainer)}
      {seo && "metaJsonLdContainer" in seo && parse(seo.metaJsonLdContainer)}
      {seo && "metaLinkContainer" in seo && parse(seo.metaLinkContainer)}
      {seo && "metaScriptContainer" in seo && parse(seo.metaScriptContainer)}

      <script>{`
        window.ap3c = window.ap3c || {};
        var ap3c = window.ap3c;
        ap3c.cmd = ap3c.cmd || [];
        ap3c.cmd.push(function() {
            ap3c.init('YTgtF4CJX0crde9SY29kZWZvcmF1c3RyYWxpYQ','https://capture-api.autopilotapp.com/');
            ap3c.track({v: 0});
        });
        var s, t; s = document.createElement('script'); s.type = 'text/javascript'; s.src = "https://cdn2l.ink/app.js";
        t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);
      `}</script>
    </Helmet>
  )
}
